<template>
	<div class="pc-navbar" id="nav" :style="{ width: screenWidth }"
		:class="isPhone == 'true' ? 'mobile' : { color: color }">
		<div class="navbar_main">
			<div>
				<div class="logo" @click="goIndex">
					<img src="@comm/images/document-conversion/home/logo.png" alt />
					<span>数科OFD</span>
				</div>
				<div class="left">
					<span class="tips">限免半年</span>
					<div class="nav-list">
						<div v-for="(item, index) in navList" :key="index">
							<div class="nav-item" :class="{ active: path == item.path }" v-if="item.path">
								<router-link :to="item.path">{{ item.name }}</router-link>
							</div>
							<div class="nav-item" v-else :class="{
							    active: currentIndex==index
							}">
								<span>
									{{ item.name }}
									<i class="el-icon-arrow-down"></i>
								</span>
								<div class="sub-menu-wrapper">
									<ul class="sub-menu">
										<li class="sub-menu-item" v-for="(items, indexs) in item.chliden" :key="indexs"
											@click="jumpPage(items,index)">
											<img :src="items.img" alt />
											<span>{{ items.name }}</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="right">
				<div v-if="!isPrivate">
					<el-button type="text" v-if="isPhone != 'true'" class="text_button"
						@click="downProduct(indexPath, 'downBox')">产品免费下载</el-button>
					<el-button type="text" class="text_button wpslogin_btn" @click="loginBtn" v-if="!userInfo">登录
					</el-button>
					<div v-else class="avatar-container pic_img"
						style="display: inline-block; margin-left: 30px; position: relative"
						@mouseenter="isShowCenterwps = true" @mouseleave="isShowCenterwps = false">
						<div class="avatar-wrapper">
							<img style="width: 44px; height: 44px; border-radius: 50%; cursor: pointer; vertical-align: middle"
								v-if="userInfo && userInfo.avatar" :src="userInfo.avatar" alt />
							<img v-else
								style="width: 44px; height: 44px; border-radius: 50%; vertical-align: middle; cursor: pointer"
								src="@comm/images/cloud-document/ofd_reader_e_32.jpg" alt />
							<ul v-if="isShowCenterwps" class="el-dropdown-menu el-popper user-dropdown wpscenter"
								id="dropMenu" x-placement="bottom-end">
								<img v-if="userInfo && userInfo.avatar"
									style="width: 34px; height: 34px; border-radius: 50%; margin: 20px auto 4px; display: block"
									:src="userInfo.avatar" alt />
								<img v-else
									style="width: 34px; height: 34px; border-radius: 50%; margin: 20px auto 4px; display: block"
									src="@comm/images/cloud-document/ofd_reader_e_32.jpg" alt />
								<a v-if="userInfo" :title="userInfo.nickname ? userInfo.nickname : '数科网维'"
									class="nickname">{{ userInfo.nickname ? userInfo.nickname : '数科网维' }}</a>
								<li tabindex="-1" class="el-dropdown-menu__item" @click="wpsLogoutBtn"
									style="color: #131415;">
									<!---->
									退出登录
								</li>
								<div x-arrow class="popper__arrow" style="left: 47px"></div>
							</ul>
						</div>
					</div>
				</div>
				<!-- <el-button type="primary" class="text_button" @click="loginBtn">登录</el-button> -->
				<div v-else class="avatar-container pic_img" @mouseenter="isShowCenter = true"
					@mouseleave="isShowCenter = false">
					<div class="avatar-wrapper">
						<img style="width: 32px; height: 32px; border-radius: 50%; cursor: pointer; vertical-align: middle"
							v-if="userInfo && userInfo.headUrl" :src="userInfo.headUrl" alt />
						<img v-else
							style="width: 32px; height: 32px; border-radius: 50%; vertical-align: middle; cursor: pointer"
							src="@comm/images/cloud-document/ofd_reader_e_32.jpg" alt />
						<ul v-if="isShowCenter" class="el-dropdown-menu el-popper user-dropdown center" id="dropMenu"
							x-placement="bottom-end">
							<img v-if="userInfo && userInfo.headUrl"
								style="width: 50px; height: 50px; border-radius: 50%; margin: 0 auto 20px; display: block"
								:src="userInfo.headUrl" alt />
							<img v-else
								style="width: 50px; height: 50px; border-radius: 50%; margin: 0 auto 20px; display: block"
								src="@comm/images/cloud-document/ofd_reader_e_32.jpg" alt />

							<span class="user-name" v-if="userInfo">{{ userInfo.realName }}</span>
							<li tabindex="-1" class="el-dropdown-menu__item" @click="logout">
								<!---->
								退出登录
							</li>
							<div x-arrow class="popper__arrow" style="left: 151.5px"></div>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import common from "@comm/utils/common";
import { getUserInfo, setToken, getToken, setUserInfo } from "@comm/utils/auth";
import { logout, getWpsUserInfo, logoutWps } from "@comm/api/public-user/user";
import { getChliden } from "@comm/api/document-conversion";
export default {
	name: "headerPage",
	data() {
		return {
			openIndex: 0,
			currentIndex: 0,
			currentSubIndex: -1,
			chooseLevelIndex: -1,
			subWidth: 0,
			isShowSub: true,
			cateList: [],
			isPhone: false,
			info: {},
			APIPort: process.env.APIPort,
			indexPath: this.APIPort == 8014 ? "/index" : "/",
			current: -1,
			color: false,
			isMobileNav: false,
			path: "",
			screenWidth: document.documentElement.clientWidth,
			userInfo: null,
			isShowCenter: false,
			isShowCenterwps: false,
			code: null,
			chliden: []
		};
	},
	computed: {
		navList() {
			const navList = [
				{ path: "/", name: "首页" },
				{
					path: ``, name: "行业应用", chliden: [
						{ path: `/InApplication/`, name: "电子发票",img: require("@comm/images/document-conversion/notice/notice_icon_04.png") },
						{ path: `/electronicCertificate`, name: "电子凭证",img: require("@comm/images/document-conversion/notice/notice_icon_05.png") }
					]
				},
				{
					path: ``,
					name: "格式转换",
					chliden: this.chliden
				},
				{ path: `/onlinePreview/`, name: "在线预览" },
				{ path: `/attestationPage`, name: "在线验签" },
				{
					path: ``, name: "服务与帮助", chliden: [
						{ path: `/service`, name: "联系我们",img: require("@comm/images/document-conversion/notice/notice_icon_02.png") },
						{ path: `/announcement`, name: "安全公告", img: require("@comm/images/document-conversion/notice/notice_icon_01.png") },
						{ path: `/aboutUs`, name: "关于我们", img: require("@comm/images/document-conversion/notice/about.svg") }
					]
				},
				{
					path: ``, name: "平台服务", chliden: [
						{ path: `https://satl.ofd.cn`, target:true, name: "SATL计划", img: require("@comm/images/document-conversion/notice/satl.svg") },
						// { path: `https://open.ofd.cn`, target: true, name: "开放平台", img: require("@comm/images/document-conversion/notice/open.svg") }
					]
				}
			];
			return navList;
		},
		isPrivate() {
			return this.APIPort === 8014 ? true : false;
		}
	},
	watch: {
		$route(to, from) {
			console.log(1,to.path)
			this.path = to.path;
		},
		screenWidth(val) {
			// 为了避免频繁触发resize函数导致页面卡顿，使用定时器
			// 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
			this.screenWidth = val;
			let that = this;
			setTimeout(function () {
				// 打印screenWidth变化的值
				that.screenWidth = that.isPhone == "true" ? that.screenWidth + "px" : that.screenWidth - 17 + "px";
			}, 400);
		}
	},
	created() {
		let chliden = [
			{
				path: `/domConversionOfd/?type=ofdtopdf`,
				name: "OFD转PDF",
				img: require("@comm/images/document-conversion/homeSVG/nav_2.svg")
			},
			{
				path: `/domConversionOfd/?type=toofd`,
				name: "Excel转OFD",
				img: require("@comm/images/document-conversion/homeSVG/nav_6.svg")
			},
			{
				path: `/domConversionOfd/?type=toofd`,
				name: "Word转OFD",
				img: require("@comm/images/document-conversion/homeSVG/nav_8.svg")
			},
			{
				path: `/domConversionOfd/?type=toofd`,
				name: "PPT转OFD",
				img: require("@comm/images/document-conversion/homeSVG/nav_7.svg")
			},
			{
				path: `/imgConversion/?type=toofd`,
				name: "图片转OFD/PDF",
				img: require("@comm/images/document-conversion/homeSVG/nav_3.svg")
			},
			{
				path: `/imgConversion/?type=toimg`,
				name: "OFD/PDF转图片",
				img: require("@comm/images/document-conversion/homeSVG/nav_4.svg")
			},
			{
				path: `/domConversionOfd/?type=toofd`,
				name: "其他转OFD",
				img: require("@comm/images/document-conversion/homeSVG/nav_1.svg")
			},
			{
				path: `/domConversionOfd/?type=topdf`,
				name: "其他转PDF",
				img: require("@comm/images/document-conversion/homeSVG/nav_5.svg")
			}
		]
		this.chliden = chliden
		this.userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
		this.path = this.$route.path;
		if (this.APIPort === 8001) {
			this.code = this.$route.query.code ? this.$route.query.code : null;
			if (this.code && !this.userInfo) {
				this.getUserInfoWps();
			}
		}
		this.path = this.$route.path;
		if (this.path == '/' || this.path == '/aboutUs' || this.path == '/onlinePreview/' || this.path == '/feedback' || this.path == '/feedbackData' || this.path == '/attestationPage') {
			localStorage.setItem('index', 0)
		}
		this.currentIndex = localStorage.index
		this.isPhone = localStorage.getItem("isPhone");
		this.screenWidth = this.isPhone == "true" ? document.documentElement.clientWidth + "px" : document.documentElement.clientWidth - 17 + "px";
	},
	mounted() {
		const that = this;
		window.onresize = () => {
			return (() => {
				window.screenWidth = document.documentElement.clientWidth;
				that.screenWidth = that.isPhone == "true" ? window.screenWidth + "px" : window.screenWidth - 17 + "px";
			})();
		};
		window.addEventListener("scroll", this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	methods: {
		getNavList() {
			getChliden({}).then((res) => {
				let data = res.data
				data = data.split(',')

				let list = []
				let chliden = [
					{
						path: `/domConversionOfd:ofdtopdf`,
						name: "OFD转PDF",
						img: require("@comm/images/document-conversion/homeSVG/nav_2.svg")
					},
					{
						path: `/domConversionOfd:toceb`,
						name: "OFD转CEB",
						img: require("@comm/images/document-conversion/nav_ceb.png")
					},
					{
						path: `/domConversionOfd:toofd`,
						name: "其他转OFD",
						img: require("@comm/images/document-conversion/homeSVG/nav_1.svg")
					},
					{
						path: `/domConversionOfd:topdf`,
						name: "其他转PDF",
						img: require("@comm/images/document-conversion/homeSVG/nav_5.svg")
					}
				]
				data.forEach(item => {
					list.push(chliden[item - 1])
				});
				this.chliden = list
			})
		},
		wpsLogoutBtn() {
			logoutWps({}).then((res) => {
				sessionStorage.clear();
				localStorage.clear();
				this.userInfo = null;
				if (this.$route.query.code) {
					if (this.$route.query.type) {
						this.$router.push({
							path: `${this.$route.path}?type=${this.$route.query.type}`
						});
					} else {
						this.$router.push({
							path: this.$route.path
						});
					}

				} else {
					this.$router.go(0);
				}
			});
		},
		getUserInfoWps() {
			getWpsUserInfo({
				code: this.code
			}).then((res) => {
				if (res.code === 100016) {
					this.$router.push({
						path: this.$route.path
					});
				} else {
					if (this.$route.query.type) {
						this.$router.push({
							path: `${this.$route.path}?type=${this.$route.query.type}`
						});
					}
					this.userInfo = res.data;
					setToken(this.userInfo.token);
					setUserInfo(JSON.stringify(this.userInfo));
					this.$emit("userInfo", { token: this.userInfo.token, suwellUserId: this.userInfo.suwellUserId });
				}
			});
		},
		goIndex() {
			if (this.$route.path == this.indexPath) {
				let toElement = document.getElementById("top");
				//锚点存在跳转
				toElement.scrollIntoView();
			} else {
				this.$router.push({ path: this.indexPath });
			}
		},
		loginBtn() {
			let path = ''
			if (this.$route.path == '/domConversionOfd/' || this.$route.path == '/imgConversion/') {
				path = `${this.$route.path}?type=${this.$route.query.type}`;
			} else {
				path = this.$route.path;
			}
			window.open(
				`https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
				"_self"
			);
		},
		handleSelect() { },
		jumpPage(item, index) {
			const { path, target } = item;
			localStorage.removeItem("toId");
			localStorage.removeItem("toNavId");
			console.log(11, index);
			this.currentIndex = index;
			localStorage.setItem('index', index)
			let page = `${this.$route.path}?type=${this.$route.query.type}`
			if (target) { 
				window.open(path, "_blank");
			}else if (path === page) {
				this.$router.go(0);
			} else if (this.$route.path == path) {
				let toElement = document.getElementById('top');
				toElement.scrollIntoView();
			} else {
				this.$router.push({ path: path });
			}
		},
		downProduct(path, id) {
			if (this.$route.path == this.indexPath || this.$route.path == "/service") {
				let toElement = document.getElementById(id);
				//锚点存在跳转
				if (id) {
					toElement.scrollIntoView();
				}
			} else {
				var path = path;
				var Id = id;
				localStorage.setItem("toNavId", Id);
				this.$router.push({ path: this.indexPath });
			}
		},
		logout() {
			this.isShowCenter = false;
			this.$confirm("确定要退出数科OFD吗?", "退出", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				cancelButtonClass: "cancelButton",
				type: ""
			})
				.then(async () => {
					logout()
						.then((res) => {
							if (res.code == 0) {
								localStorage.clear();
								window.open(common.localLoginUrl, "_self");
							}
						})
						.catch((err) => { });
				})
				.catch(() => { });
		}
	}
};
</script>

<style lang="scss">
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title,
.el-menu--horizontal>.el-menu-item,
.el-menu--horizontal>.el-menu-item.is-active {
	border-bottom-color: transparent !important;
	background: none !important;
}

.pc-navbar .content .left .el-menu--horizontal>.el-menu-item {
	background: none !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.avatar-wrapper {
	position: relative;
}

.nickname {
	width: 88px;
	font-size: 12px;
	color: #131415;
	line-height: 16px;
	text-align: center;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	margin-bottom: 8px;
	display: block;
	cursor: default;

	&:hover {
		text-decoration: none;
	}
}

.wpscenter {
	top: 60px;
	right: -32px;
	width: 104px;
	height: 114px;
	left: auto;
	padding: 0 8px;

	.el-dropdown-menu__item {
		padding: 0;
		text-align: center;
		font-size: 12px;
		color: #14a8f0;
		line-height: 30px;
		border-top: 1px #d5d5d5 dashed;

		&:hover {
			background: none !important;
			color: #15b2ff !important;
		}
	}
}

.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
	border-bottom: none;
}

.el-menu-item:hover {
	color: #15b2ff !important;
	background: none !important;
}

.el-menu-item:focus,
.el-menu-item:active {
	color: #1299d9 !important;
	background: none !important;
}

.el-submenu:focus .el-submenu__title,
.el-submenu:active .el-submenu__title,
.el-submenu:hover .el-submenu__title {
	color: #15b2ff !important;
	background: none !important;
}

.pc-navbar::-webkit-scrollbar {
	display: none;
}

.pc-navbar {
	min-width: 1200px;
	height: 72px;
	background-color: #fff;
	position: fixed;
	top: 0;
	left: 0;
	margin: 0 auto;
	box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
	z-index: 1000;

	.navbar_main {
		max-width: 1200px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 72px;
		line-height: 72px;
		margin: 0 auto;
	}

	.logo {
		display: inline-block;
		vertical-align: middle;
		cursor: pointer;

		img {
			height: 28px;
			width: auto;
			vertical-align: middle;
		}

		span {
			font-size: 20px;
			font-weight: 400;
			color: #14a8f0;
			line-height: 28px;
			margin-left: 12px;
			vertical-align: middle;
		}
	}

	.left {
		display: inline-block;
		vertical-align: middle;
		margin-left: 30px;

		.el-menu--horizontal>.el-menu-item,
		.el-menu--horizontal>.el-menu-item.is-active {
			border: none;
			background: none;
		}

		.el-menu--horizontal>.el-menu-item {
			padding: 0 20px;
			height: 72px;
			line-height: 72px;
			font-size: 16px;
		}

		.el-menu.el-menu--horizontal {
			border: none;
		}

		a:hover {
			text-decoration: none;
		}

		.tips {
			display: none;
			width: 72px;
			height: 24px;
			background: #ee544b;
			border-radius: 12px 12px 12px 0px;
			font-size: 12px;
			color: #ffffff;
			line-height: 24px;
			text-align: center;
			position: absolute;
			left: 20px;
			top: -18px;
			z-index: 999;
		}
	}

	.text_button.el-button--text {
		font-size: 16px !important;
		color: #36425a;
		border-radius: 19px !important;
		border: 1px solid #15b2ff !important;
		font-weight: 400;
		padding: 8px 23px !important;
		color: #15b2ff !important;
		width: auto;
	}

	.text_button.el-button--text:hover {
		color: #fff !important;
		background: #15b2ff !important;
	}

	.wpslogin_btn.el-button--text {
		color: #fff !important;
		background: #15b2ff !important;
	}

	.wpslogin_btn.el-button--text:hover {
		color: #fff !important;
		background: #008ad9 !important;
	}

	.el-menu-item:active {
		color: #1299d9;
	}

	.el-button+.el-button {
		margin-left: 20px;
		width: 96px;
		height: 40px;
		background: #14a8f0;
		border-radius: 2px;
	}
}

.nav-list {
	display: flex;
	justify-content: space-between;
	align-items: center;

	.nav-item {
		margin: 0 16px;
		height: 72px;
		line-height: 72px;
		font-size: 16px;
		font-weight: 400;
		color: #242f44;
		transition: 4s;

		&.active {
			color: #14a8f0;
			border-bottom: 4px solid #14a8f0;

			i,
			a {
				color: #14a8f0;
			}
		}

		i {
			color: #242f44;
		}

		a {
			color: #242f44;

			&:hover {
				color: #14a8f0;
			}
		}

		.active {
			color: #14a8f0;
		}

		>span {
			cursor: pointer;

			&:hover,
			&:hover i {
				color: #14a8f0;
			}
		}

		&:hover .sub-menu-wrapper {
			height: auto;
			padding: 16px 0 8px;
			box-shadow: 5px 5px 10px 5px rgba(179, 171, 171, 0.3);
		}

		.sub-menu-wrapper {
			position: absolute;
			left: 0;
			top: 72px;
			margin: auto;
			width: 100%;
			background-color: #fff;
			overflow: hidden;
			height: 0;
			z-index: 999;

			.sub-menu {
				width: 1200px;
				display: flex;
				flex-direction: row;
				align-items: center;
				flex-wrap: wrap;
				margin: auto;

				.sub-menu-item {
					width: 200px;
					height: 88px;
					cursor: pointer;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					margin-bottom: 8px;
					text-align: center;

					img {
						width: 48px;
						height: auto;
					}

					&:hover {
						box-shadow: 0px 2px 10px 3px rgba(77, 171, 197, 0.18);
						border: 1px solid #14a8f0;

						span {
							color: #14a8f0;
						}
					}

					span {
						font-size: 14px;
						font-weight: 400;
						color: #242f44;
						line-height: 22px;
						display: block;
						// padding-top:4px;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/headerPage.vue